import Divider from '~/themes/base/components/molecule/Divider'

export default {
  extends: Divider,
}
